// extracted by mini-css-extract-plugin
module.exports = {"base":"8px","xs":"0px","sm":"600px","md":"900px","lg":"1200px","xl":"1536px","loading":"notFoundBlock_loading__QJKCc","machine":"notFoundBlock_machine__sCyJx"};